<style lang="less" scoped>
    .container{
        margin: 0 auto;
        max-width: 800px;
    }
    .stock-edit-form {
        /deep/ .ivu-form-item-content {
          width:500px;
        }
        .stock-dosages {
          /deep/ .ivu-form-item-content {
              width: 80%;
          }
        }
    }
    .stock-is-iteration{
        /deep/ .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner{
            border-color: #2d8cf0;
            background-color: #2d8cf0;
        }
        /deep/ .ivu-checkbox-disabled.ivu-checkbox-checked .ivu-checkbox-inner:after{
            border-color: white;
        }
    }
    .stock-dosage-table{
        th{
            padding: 5px 2px;
            line-height: 1;
        }
        td{
            padding: 2px;
            line-height: 1;
           // white-space: nowrap;
        }
    }
</style>
<template>
  <div>
    <!--  :show-header-close="false" -->
    <VModal
      v-model="edit_config.modal"
      dynamic-height
      :height-rate="0.9"
      :width="900"
      :title="title"
      ok-text="保存"
      :loading="edit_config.loading"
      :show-header-close="false"
      @ok="editOkProxy"
    >
      <template v-slot:headerLast="{close}">
        <v-toolbar-items
          style="margin-right: -16px"
        >
          <v-btn
            icon
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items> 
      </template> 
      <div class="container">
        <Form
          ref="form"
          class="stock-edit-form"
          :model="edit_stock"
          :label-width="150"
        >
          <FormItem
            prop="fill_user_id"
            label="填制人"
          >
            <span class="color-disabled">{{ edit_stock.fill_user }}</span>
          </FormItem>
          <Row>
            <!-- <i-col span="12">
              <FormItem
                prop="is_iteration"
                class="stock-is-iteration"
                label="新品/迭代"
              >
                <Checkbox
                  :value="!edit_stock.is_iteration"
                  :disabled="!!edit_stock.id || !edit_stock.is_iteration"
                  @on-change="iterationChange(false)"
                >
                  新品
                </Checkbox>
                <Checkbox
                  :value="edit_stock.is_iteration"
                  :disabled="!can_edit"
                  @on-change="iterationChange(true)"
                >
                  迭代
                </Checkbox>
              </FormItem>
            </i-col> -->
            <!--  <i-col span="12">
              <FormItem
                v-if="edit_stock.id && is_financer_stock"
                prop="del"
                label="废弃"
              >
                <Checkbox v-model="edit_stock.del">
                  废弃存货
                </Checkbox>
              </FormItem>
            </i-col> -->
          </Row>
          <!-- <FormItem
            v-if="edit_stock.id && is_financer_stock"
            prop="del"
            label="废弃"
          >
            <Checkbox v-model="edit_stock.del">
              废弃存货
            </Checkbox>
          </FormItem> -->
          <!-- <FormItem
            v-if="edit_stock.del"
            prop="del_reason"
            label="废弃原因"
            :rules="{ required: true, message: '废弃原因不能为空'}"
          >
            <p v-if="del_reason_disabled">
              {{ edit_stock.del_reason }}
            </p>
            <Input
              v-else
              v-model="edit_stock.del_reason"
              :disabled="del_reason_disabled"
              type="textarea"
              placeholder="请输入..."
            />
          </FormItem> -->
          <!-- <FormItem
            prop="is_assemble"
            label="组合/赠品"
          >
            <Checkbox 
              v-model="edit_stock.is_assemble"
              :disabled="shouldDisable()"
            >
              是否为组合存货
            </Checkbox>
            <Checkbox
              v-model="edit_stock.is_gift"
              :disabled="shouldDisable()"
            >
              是否为赠品
            </Checkbox>
          </FormItem> -->
          <FormItem
            prop="drop_shipping"
            label="是否一件代发"
          >
            <Checkbox
              v-model="edit_stock.drop_shipping"
              :disabled="shouldDisable()"
              @on-change="dropChange"
            >
              <!-- 占位slot -->
              <span v-show="false" /> 
            </Checkbox>
          </FormItem>
          <FormItem
            v-if="is_store||is_agreement"
            prop="auto_balance"
            label="自动调节库存"
          >
            <Checkbox
              :disabled="shouldDisable()"
              :value="edit_stock.auto_balance"
              @click.native="edit_stock.auto_balance = !edit_stock.auto_balance"
              @on-change="autoBalanceChange"
            >
              <!-- 占位slot -->
              <span v-show="false" /> 
            </Checkbox>
          </FormItem>
          <!-- :rules="{ required: true, message: '供应商必填'}" -->
          <FormItem
            v-if="edit_stock.drop_shipping"
            prop="payee_company_id"
            label="一件代发供应商"
          >
            <Select
              :disabled="shouldDisable(!is_apply)"
              :value="edit_stock.payee_company_id"
              placeholder="请选择供应商"
              :remote-method="dropChange"
              filterable
              :loading="getpayeeCompanyLoading"
              @on-change="changePayeeCompany"
            >
              <Option
                v-for="item in payee_company_list"
                :key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- :rules="{ required:true, message: '收货信息必选'}" -->
          <FormItem
            v-if="edit_stock.drop_shipping"
            prop="payee_company_contact_id"
            label="收货信息"
          >
            <!-- {{ payee_company_hash[edit_stock.payee_company_id].payee_company_contacts }} -->
     
            <Select
              :disabled="shouldDisable(!is_apply)"
              :value="edit_stock.payee_company_contact_id"
              placeholder="请选择供应商收货信息"
              @on-change="changePayeeCompanyConcact"
            >
              <Option
                v-for="(item,index) in payee_company_conctracts()"
                :key="item.id"
                :value="item.id"
                :label="`${item.address||'-'}/${item.contact_person || '-'}/${item.phone||'-'}`"
              >
                <div style="margin:10px 0">
                  <p>收货信息{{ index+1 }}</p>
                  <p>收货地址：{{ item.address ||'-' }}</p>
                  <p>收货人：{{ item.contact_person||'-' }}</p>
                  <p>收货电话：{{ item.phone||'-' }}</p>
                </div>
              </option>
            </Select>
          </FormItem>
          <FormItem
            v-if="edit_stock.drop_shipping"
            prop="cost_unit_price"
            label="一件代发成本单价"
            :rules="{ validator: validateNumber}"
          >
            <i-input
              v-model="edit_stock.cost_unit_price"
              :disabled="shouldDisable()"
              placeholder=""
            />
          </FormItem>
          <FormItem
            prop="apply_user_id"
            label="申请人"
            :rules="{ required: true, validator: validateId}"
          >
            <CustomerSelector
              v-model="edit_stock.apply_user_id"
              formal
              :disabled="shouldDisable()"
              @on-change="setApplyUser"
            >
              <span v-if="edit_stock.apply_user">{{ edit_stock.apply_user }}</span>
              <span
                v-else
                class="color-grey"
              >选择</span>
            </CustomerSelector>
          </FormItem>
          <FormItem
            prop="team_id"
            label="所属团队"
            :rules="{ required: true, validator: validateId}"
          >
            <Select 
              v-model="edit_stock.team_id"
              :disabled="shouldDisable()"
            >
              <Option
                v-for="team in teams"
                v-show="!team.del"
                :key="team.id"
                :value="team.id"
              >
                {{ team.name }}
              </Option>
            </Select>
          </FormItem>
          <!-- <FormItem
            v-if="is_agreement"
            prop="use_team_id"
            label="使用团队"
            :rules="{ required: true, validator: validateId}"
          >
            <Select 
              v-model="edit_stock.use_team_id"
              :disabled="shouldDisable()"
            >
              <Option
                v-for="team in teams"
                v-show="!team.del"
                :key="team.id"
                :value="team.id"
              >
                {{ team.name }}
              </Option>
            </Select>
          </FormItem> -->
          <!-- <FormItem
            v-if="is_financer_stock"
            prop="company_code"
            label="业务所属公司"
            :rules="{ required: true, message: '请选择业务所属公司'}"
          >
            <Select
              v-model="edit_stock.company_code"
              :disabled="shouldDisable(is_finish)"
            >
              <Option value="CYA">
                超有爱
              </Option>
              <Option value="LS">
                良师益友
              </Option>
            </Select>
          </FormItem> -->
          <!--
         -->
          <!-- <FormItem
            v-if="edit_stock.is_iteration"
            prop="uid"
            label="存货编码"
            :rules="{ required: true, message: '存货编码不能为空'}"
          >
            <ParentStockSelector
              v-if="!edit_stock.uid"
              v-model.trim="edit_stock.uid"
              @on-select="setIterationStock"
            >
              <div class="ivu-select ivu-select-single ivu-select-default">
                <div class="ivu-select-selection">
                  <div class="ivu-select-selected-value">
                    <span v-if="edit_stock.uid">{{ edit_stock.uid }}</span>
                    <span
                      v-else
                      class="color-grey"
                    >请选择迭代存货</span>
                  </div>
                </div>
              </div>
            </ParentStockSelector>
            <Button
              v-else
              :disabled="!!edit_stock.uid"
            >
              {{ edit_stock.uid }}
            </Button>
          </FormItem> -->
          <FormItem
            v-if="is_financer_stock"
            prop="group"
            label="产品分类"
            :rules="{ required: true, message: '请选择产品分类'}"
          >
            <Select
              v-model="edit_stock.group"
              :disabled="shouldDisable(!is_financer_stock)"
              placeholder="产品分类"
            >
              <Option
                v-for="group in groups"
                :key="group.code"
                :disabled="group.property==='Service'"
                :value="group.code"
                @click.native="setProperty(group)"
              >
                {{ group.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            prop="product_type_id"
            label="电商目录"
            :rules="{ required: true, message: '请选择电商目录'}"
          >
            <div
              slot="label"
              style="display: inline"
            >
              电商目录    <Tooltip
                content="配件：仅用于委外关系中的子件；包装物-专：日常体现在发货单、月末不需履约统计出库的的包装耗材"
                placement="top-start"
              >
                <div slot="content">
                  <div>配件：仅用于委外关系中的子件；</div>
                  <div>包装物-专：日常体现在发货单、月末不需履约统计出库的的包装耗材；</div>
                  <div>包装物-通用：日常不体现在发货单、月末由履约根据实际消耗数量出库的包装耗材；</div>
                  <div>文创：除数码/文具外的其他，兜底项；</div>
                  <div>玩具：不附带教学服务；</div>
                  <div>教具：附带教学服务；</div>
                </div>
                <Icon
                  size="16"
                  type="md-help-circle"
                />
              </Tooltip>
            </div>
            <ProductTypeSelector
              :disabled="shouldDisable(!is_apply)"
              @on-change="setProductType"
            >
              <div :class="['ivu-select','ivu-select-single', 'ivu-select-default',shouldDisable(!is_apply)&&'ivu-select-disabled'].join(' ')">
                <div class="ivu-select-selection">
                  <div class="ivu-select-selected-value">
                    <span v-if="edit_stock.product_type_id">{{ edit_stock.product_type_name }}</span>
                    <span
                      v-else
                      class="color-grey"
                    >请选择电商类目</span>
                  </div>
                </div>
              </div>
            </ProductTypeSelector>
          </FormItem>
          <!-- <FormItem
            v-if="is_financer_stock"
            prop="property"
            label="产品属性"
            :rules="{ required: true, message: '请选择产品属性'}"
          >
            <Select
              v-model="edit_stock.property"
              placeholder="产品属性"
              :disabled="!!edit_stock.property"
            >
              <Option value="SelfMade">
                自制产品
              </Option>
              <Option value="Service">
                服务类产品
              </Option>
            </Select>
          </FormItem> -->
          <FormItem
            prop="name"
            label="产品名称"
            :rules="[{ required: true, message: '产品名称不能为空'},{
              validator:validateSpecial
            }]"
          >
            <i-input
              v-model.trim="edit_stock.name"
              :disabled="shouldDisable()"
              type="text"
              placeholder="名称..."
            />
          </FormItem>
          <FormItem
            prop="cya_spu_id"
            label="SPU"
            :rules="[{ required: true, message: 'SPU不可为空'}]"
          >
            <CyaSpuSelector
              :disabled="shouldDisable(!is_apply)"
              @on-change="setCyaSpu"
            >
              <div :class="['ivu-select','ivu-select-single', 'ivu-select-default',shouldDisable(!is_apply)&&'ivu-select-disabled'].join(' ')">
                <div class="ivu-select-selection">
                  <div class="ivu-select-selected-value">
                    <span v-if="edit_stock.cya_spu_id">{{ edit_stock.cya_spu_name }}</span>
                    <span
                      v-else
                      class="color-grey"
                    >请选择SPU</span>
                  </div>
                </div>
              </div>
            </CyaSpuSelector>
          </FormItem>
          <!-- <FormItem
            v-if="!is_service"
            prop="name_en"
            label="英文名"
          >
            <i-input
              v-model.trim="edit_stock.name_en"
              :disabled="shouldDisable(is_finish)"
              placeholder="英文名"
            />
          </FormItem> -->
          <FormItem
            prop="stock_unit_id"
            label="单位"
            :rules="{ required: true, validator: validateId}"
          >
            <Select 
              v-model="edit_stock.stock_unit_id"
              :disabled="shouldDisable(!is_apply)"
            >
              <Option
                v-for="unit in stock_units"
                :key="unit.id"
                :value="unit.id"
              >
                {{ unit.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            prop="imported"
            label="是否进口"
            :rules="{ required: true, message: '必选'}"
          >
            <RadioGroup
              v-model="edit_stock.imported"
            >
              <Radio
                label="true"
              >
                是
              </Radio>
              <Radio
                label="false"
              >
                否
              </Radio>
            </RadioGroup>
          </FormItem>
          <!--<FormItem prop="brand" label="品牌名称" :rules="{ required: true, message: '请选择品牌名称'}">
                        <Select v-model="edit_stock.brand" placeholder="品牌名称">
                            <Option v-for="team in teams" :value="team.name" :key="team.id" v-if="!team.del">{{team.name}}</Option>
                        </Select>
                    </FormItem>-->
          <!-- <FormItem
            v-if="!is_service"
            prop="keyword"
            label="关键字"
            :rules="{ required: true, message: '请填写关键字'}"
          >
            <i-input
              v-model="edit_stock.keyword"
              type="textarea"
              placeholder="简要描述该产品分类、用处"
            />
          </FormItem> -->
          <!-- :rules="{ required: true, message: '请填写规格型号'}" -->
          <FormItem
            prop="spec"
            label="规格型号"
          >
            <i-input
              v-model="edit_stock.spec"
              :disabled="shouldDisable(!is_apply)"
              type="textarea"
              placeholder="简要描述产品规格大小及一套有多少个等"
              :maxlength="100"
            />
          </FormItem>
          <FormItem
            prop="desc"
            label="备注"
          >
            <i-input
              v-model="edit_stock.desc"
              type="textarea"
              placeholder="备注..."
            />
          </FormItem>
          <!--  :rules="{ required: true, validator: validateId}" -->
          <FormItem
            v-if="!edit_stock.drop_shipping"
            prop="barcode"
            label="69码"
            :rules="[{
              trigger: 'blur' ,
              validator:check69 ,
            }]"
          >
            <div>
              <i-input
                v-model="edit_stock.barcode"
                :disabled="shouldDisable()"
                placeholder="69码..."
                :maxlength="14"
              />
              <div style="line-height:16px;color:red;margin-top:5px">
                69码可与ISBN码相同，但需通过唯一性验证，否则请单独申请69码，请谨慎填写。
              </div>
            </div>
          </FormItem>
          <FormItem
            v-if="show_isbn"
            prop="isbn"
            label="ISBN码"
            :rules="{ required: true, validator: validateIsbn}"
          >
            <div>
              <div style="display:flex">
                <Select
                  v-model="edit_stock._isbn_status"
                  style="width:140px;margin-right:10px"
                >
                  <Option
                    v-for="(i,index) in isbn_input"
                    :key="index"
                    :value="i.value"
                  >
                    {{ i.label }}
                  </Option>
                </Select>
                <i-input
                  v-if="edit_stock._isbn_status==='1'"
                  v-model="edit_stock.isbn"
                  style="flex:1"
                  placeholder="若选择[已有ISBN码]，则需要在此输入"
                />
                <Select 
                  v-if="edit_stock._isbn_status==='3'"
                  v-model="edit_stock.isbn_delay.days"
                  style="flex:1"
                >
                  <Option
                    v-for="(i,index) in isbn_date"
                    :key="index"
                    :value="i.value"
                  >
                    {{ i.label }}
                  </Option>
                </Select>
              </div>
              <!-- <div style="line-height:16px;color:red;margin-top:5px">
                69码/isbn号唯一性验证已开启，请注意同一商品不同69码/isbn号不能重复使用，请谨慎填写
              </div> -->
            </div>
          </FormItem>
          <!-- <FormItem
            v-if="!is_service"
            prop="launch_date"
            label="上市时间"
            :rules="{ required: true, message: '请选择上市时间'}"
          >
            <Date-picker
              type="date"
              :value="edit_stock.launch_date"
              placeholder="选择上市时间"
              @on-change="launchDateChange"
            />
          </FormItem> -->
          <!-- <div v-if="edit_stock.is_assemble">
            <FormItem
              class="stock-dosages"
              prop="stock_dosages"
              label="组合存货用量"
            >
              <table class="mis-table stock-dosage-table">
                <tr>
                  <th>存货编码</th>
                  <th style="min-width:200px">
                    存货名称
                  </th>
                  <th style="min-width:50px">
                    团队
                  </th>
                  <th style="min-width:30px">
                    用量
                  </th>
                  <th style="min-width:50px">
                    备注
                  </th>
                  <th style="min-width:53px">
                    操作
                    <Button
                      v-if=" !shouldDisable()&&edit_stock.stock_dosages.length === 0"
                      size="small"
                      shape="circle"
                      type="primary"
                      icon="md-add"
                      @click="addStockDosage"
                    />
                  </th>
                </tr>
                <tr
                  v-for="(stock_dosage, index) in edit_stock.stock_dosages"
                  :key="index"
                >
                  <td>
                    <StockSelector
                      v-model="stock_dosage.stock_id"
                      :disabled="shouldDisable()"
                      @on-update="function(stock){setStockDosage(stock_dosage, stock)}"
                    >
                      <span
                        v-if="stock_dosage.sub_stock_id"
                        :class="{
                          link: !shouldDisable()
                        }"
                      >{{ stock_dosage.stock_uid }}</span>
                      <span v-else-if="stock_dosage.stock_uid ">
                        {{ stock_dosage.stock_uid }}
                      </span>
                      <span
                        v-else
                        :class="{
                          link: !shouldDisable()
                        }"
                      >{{ !shouldDisable()&&'请选择'||'' }}</span>
                    </StockSelector>
                  </td>
                  <td>
                    <div style="max-width:300px">
                      {{ stock_dosage.stock_name || '-' }}
                    </div>
                  </td>
                  <td><TeamName :id="stock_dosage.team_id" /></td>
                  <td>
                    <i-input
                      v-model="stock_dosage.qty"
                      :disabled="shouldDisable()"
                      size="small"
                    />
                  </td>
                  <td>
                    <i-input
                      v-model="stock_dosage.remark"
                      :disabled="shouldDisable()"
                      size="small"
                      placeholder="备注"
                    />
                  </td>
                  <td>
                    <div>
                      <Button
                        v-if="!shouldDisable()&&index === edit_stock.stock_dosages.length - 1"
                        size="small"
                        shape="circle"
                        type="primary"
                        icon="md-add"
                        @click="addStockDosage"
                      />
                      <Poptip
                        confirm
                        title="你确定要删除吗?"
                        @on-ok="delStockDosage(stock_dosage, index)"
                      >
                        <Button
                          v-if="!shouldDisable()"
                          size="small"
                          shape="circle"
                          type="warning"
                          icon="md-close"
                        />
                      </Poptip>
                    </div>
                    <span />
                  </td>
                </tr>
              </table>
            </FormItem>
          </div> -->
          <!-- <FormItem
            prop="stock_img"
            label="产品图片"
          >
            <FileUploader
              :disabled="shouldDisable(is_finish)"
              :upload_path="upload_to_oss_public"
              :format="['jpg', 'jpeg', 'png']"
              @done="uploadedFile"
            >
              <div class="stock-img">
                <img
                  v-if="edit_stock.stock_img"
                  :src="fileUrl(edit_stock.stock_img)"
                >
                <Icon
                  v-else
                  type="ios-image-outline"
                  color="#aaaaaa"
                  size="120"
                />
              </div>
            </FileUploader>
          </FormItem> -->
          <!-- <FormItem
            v-if="!is_service"
            prop="barcode_img"
            label="条码图片"
          >
            <FileUploader
              :upload_path="upload_to_oss_public"
              :format="['jpg', 'jpeg', 'png']"
              @done="uploadedBarcode"
            >
              <div class="stock-img">
                <img
                  v-if="edit_stock.barcode_img"
                  :src="fileUrl(edit_stock.barcode_img)"
                >
                <Icon
                  v-else
                  type="ios-barcode"
                  color="#aaaaaa"
                  size="120"
                />
                <Button
                  v-if="edit_stock.barcode_img"
                  @click.stop="uploadedBarcode({file: ''})"
                >
                  清除
                </Button>
              </div>
            </FileUploader>
          </FormItem> -->
          <FormItem
            v-if="is_financer_stock"
            prop="company_code"
            label="所属公司"
            :rules="{ required: true, message: '请选择所属公司'}"
          >
            <Select
              v-model="edit_stock.company_code"
              :disabled="shouldDisable(!is_financer_stock)"
            >
              <Option value="CYA">
                超有爱
              </Option>
              <Option value="LS">
                良师益友
              </Option>
              <Option value="ZS">
                终身成长
              </Option>
            </Select>
          </FormItem> 
          <FormItem
            v-if="is_financer_stock"
            prop="tax_code_id"
            label="税收编码"
            :rules="{ required: true, validator: validateId}"
          >
            <Select
              v-model="edit_stock.tax_code_id"
              :disabled="shouldDisable(!is_financer_stock)"
            >
              <Option
                v-for="tax_code in tax_codes"
                :key="tax_code.id"
                :value="tax_code.id"
              >
                {{ tax_code.name }}-{{ tax_code.code }}
              </Option>
            </Select>
          </FormItem>
          <FormItem
            v-if="is_financer_stock"
            prop="uid"
            label="存货编码"
            :rules="{ required: true, message: '存货编码不能为空'}"
          >
            <i-input
              v-model.trim="edit_stock.uid"
              :disabled="shouldDisable()"
              type="text"
              placeholder="存货编码"
            />
          </FormItem> 
          <FormItem
            v-if="edit_stock.id && is_financer_stock"
            prop="del"
            label="作废存货"
          >
            <Checkbox
              v-model="edit_stock.del"
              :disabled="shouldDisable(!is_financer_stock)"
            >
              <span v-show="false" /> 
            </Checkbox>
          </FormItem>
          <FormItem
            v-if="edit_stock.id &&edit_stock.del&&is_financer_stock"
            prop="del_reason"
            label="废弃原因"
            :rules="{ required: true, message: '废弃原因不能为空'}"
          >
            <p v-if="del_reason_disabled">
              {{ edit_stock.del_reason }}
            </p>
            <Input
              v-else
              v-model="edit_stock.del_reason"
              :disabled="shouldDisable(!is_financer_stock)"
              type="textarea"
              placeholder="请输入..."
            />
          </FormItem>
          <FormItem
            prop="outsourcing"
            label="是否委外"
          >
            <Checkbox
              v-model="edit_stock.outsourcing"
              :disabled="shouldDisable(!is_financer_stock)"
            >
              <!-- 占位slot -->
              <span v-show="false" /> 
            </Checkbox>
          </FormItem>
          <FormItem
            v-if="edit_stock.outsourcing"
            prop="outsource_relation"
            label="委外关系"
            :rules="{ required: true, message: '委外关系不能为空'}"
          >
            <i-input
              v-model.trim="edit_stock.outsource_relation"
              :disabled="shouldDisable(!is_financer_stock)"
              placeholder="委外关系"
            />
          </FormItem>
        </Form>
      </div>
    </VModal>
  </div>
</template>
<script>
  import { str2num } from '@/libs/number_util.js'
  import { mapGetters } from "vuex";
  import { util_api } from '@/libs/util_api'
  import { throttle } from '@/libs/functions_utils'
  import StockUtil from '../libs/util';
  import { isbn_input, isbn_date } from '../libs/fields';
  import TeamName from '../../team/components/name';
  import CustomerSelector from '../../components/customer/selector';
  import StockSelector from './stock_selector';
  import ParentStockSelector from './parent_stock_selector';
  import ProductTypeSelector from './product_type_selector';
  import CyaSpuSelector from './cya_spu_selector';
  import FileUploader from '../../components/file/uploader';
  import CustomerUtil from '@/views/components/customer/libs/util.js'
  import stockMixIn from '../mixins/stock'
  import {stockBarcodeValidateApi, getSpuList} from '../service'
  import VModal from '@/vuetify_custom/v-modal_v1'
  const { query_payee_company, query_payee_company_withid } = util_api

  export default {
    components: { TeamName, CustomerSelector, FileUploader, StockSelector, ParentStockSelector, ProductTypeSelector, CyaSpuSelector, VModal },
    mixins:[stockMixIn],
    props: {
      role: {
        type: String,
        default: 'staff' // staff: 员工, financer: 财务人员
      },
      stock_units: {
        type: Array
      }
    },
    data() {
      this.query_payee_company = query_payee_company
      this.payee_company_hash = {}
      this.isbn_input = isbn_input
      this.isbn_date = isbn_date
      return {
        update_item_path: this.$util.api.update_stock,
        upload_to_oss_public: this.$util.api.upload_to_oss_public,
        edit_config: {
          modal: false,
          loading: false
        },
        tax_codes: [],
        groups: StockUtil.groups,
        edit_stock: StockUtil.new_stock(),
        del_reason_disabled: false,
        payee_company_list: [],
        // payee_company_conctracts: [],
        getpayeeCompanyLoading: false,
        is_init: false,
        is_finish: false,
        has_barcode: false,
        spuList: []
      } 
    },
    computed: {
      show_isbn() {
        return this.edit_stock && this.edit_stock.product_type_name && this.edit_stock.product_type_name.slice(0, 2) === '图书'
      },
      title() {
        return this.edit_stock.id ? '编辑存货' : '添加存货';
      },
      ...mapGetters({
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
        companies: 'async/companies',
        //  is_financer_stock: 'is_financer_stock',
        // cur_customer: 'async/cur_customer'
      }),
      is_service() {
        return this.edit_stock.property === 'Service';
      },
      is_apply() {
        const cur_customer_id = this.cur_customer.id
        const {apply_user_id, fill_user_id} = this.edit_stock
        const clould_arr = [ apply_user_id, fill_user_id]
        return clould_arr.includes(cur_customer_id)
      }
      // is_finish() {
      //   const user_flow = this.edit_stock.user_flow;
      //   return (this.edit_stock.id && !user_flow) || (user_flow && user_flow.is_finish);
      // }
    },
    watch: {
      cur_customer() {
        this.setFillUser(this.cur_customer);
        this.setApplyUser(this.cur_customer);
        // this.setTeam(this.cur_customer);
      }
    },
    created() {
      this.getTaxCodes();
      this.fetchSpu();
    },
    mounted() {
      //
    },
    methods: {
      fetchSpu() {
        getSpuList().then(res => {
          this.spuList = res
        })
      },
      check69(rule, value, callback) {
        if (!value) {
          callback();
           
        }
        if (value.length < 12) {
          callback(new Error('69码长度不能小于12位'));
        } else if (value.length > 14) {
          callback(new Error('69码长度不能大于14位'));
        }
        callback();

      },
      payee_company_conctracts() {
        if (!this.edit_stock || !this.edit_stock.payee_company_id) {
          return []
        }
        const payee_company = this.payee_company_hash[this.edit_stock.payee_company_id]
        return payee_company && payee_company.payee_company_contacts || []
       
      },
      shouldDisable(...arg) {
        arg = arg.concat(this.is_finish)
        return arg.every(i => i)
      },
      changePayeeCompanyConcact(data) {
        if (!data) {
          return 
        }
        this.edit_stock.payee_company_contact_id = data
      },
      changePayeeCompany(data) {
        if (!data) {
          return 
        }
        if (data !== this.edit_stock.payee_company_id) {
          this.edit_stock.payee_company_contact_id = null
        }
        this.edit_stock.payee_company_id = data
        // if (data && this.payee_company_list) {
        //   const payee_company = this.payee_company_hash[data]
        //   this.payee_company_conctracts = payee_company.payee_company_contacts
        // }
      },
      dropChange(search) {
        if (!this.throttle_ac) {
          // 截流
          this.throttle_ac = throttle.call(this, this.getPayeeCompanyList, 200)
        }
        this.throttle_ac(search)
      },
      getPayeeCompanyList(search) {
        if (search) {
          this.getpayeeCompanyLoading = true
          this.$http.get(query_payee_company, {
            page:1,
            per_page: 20,
            search
          }).then(res => {
            res.payee_companies.forEach(item => {
              this.$set(this.payee_company_hash, item.id, item)
              // this.payee_company_hash[item.id] = item
            })
            if (this.edit_stock.payee_company_id && !res.payee_companies.some(item => item.id === this.edit_stock.payee_company_id)) {
              res.payee_companies.push(this.payee_company_hash[this.edit_stock.payee_company_id])
            }
            this.payee_company_list = res.payee_companies
          }).finally(() => {
            this.getpayeeCompanyLoading = false
          })
        }
      },
      init() {
        if (this.cur_customer && this.cur_customer.id) {
          this.setFillUser(this.cur_customer);
          this.setApplyUser(this.cur_customer);
          // this.setTeam(this.cur_customer);
        }
        // 
        this.edit_stock.auto_balance = true
      },
      autoBalanceChange() {
        if (this.edit_stock.auto_balance === false) {
          this.$Modal.confirm({
            title: '提示',
            content: '取消勾选将不再自动调整渠道库存，确认取消吗?',
            onOk: () => {
              return;
            },
            onCancel: () => {
              this.edit_stock.auto_balance = true;
              return;
            }
          })
        }
      },
      edit(stock) {
        this.edit_config.modal = true
        setTimeout(() => {
          this.$refs.form.resetFields();
          this.del_reason_disabled = false
          // this.payee_company_conctracts = []
          this.payee_company_list = []
          if (stock && stock.id) {
            this.$set(this, 'edit_stock', this.$util.clone(stock));
            this.del_reason_disabled = stock.del
            if (stock.drop_shipping || stock.payee_company_id) {
              this.$http.get(query_payee_company_withid, {
                id: stock.payee_company_id
              }).then(res => {
                this.payee_company_list = res
                this.payee_company_list.forEach(item => {
                  this.$set(this.payee_company_hash, item.id, item)
                })
                //  console.log('this.payee_company_hash', this.payee_company_hash)
                this.changePayeeCompany(stock.payee_company_id)
              })

            }

            const user_flow = stock.user_flow;
            this.is_init = !user_flow 
            this.is_finish = user_flow && user_flow.is_finish || false
            this.has_barcode = !!stock.barcode
            this.$set(this.edit_stock, '_isbn_status', null);
            if (!stock.isbn_delay) {
              this.$set(this.edit_stock, 'isbn_delay', {
                days: null
              });
            } else {
              this.edit_stock._isbn_status = '3'
            }
            if (this.edit_stock.isbn) {
              this.edit_stock._isbn_status = '1'
            }
            if (! this.edit_stock._isbn_status) {
              this.edit_stock._isbn_status = '2'
            }
            if (stock.imported === true) {
              this.edit_stock.imported = 'true'
            } else if (stock.imported === false) {
              this.edit_stock.imported = 'false'
            }
          } else {
            this.has_barcode = false
            this.is_init = true
            this.is_finish = false
            this.$set(this, 'edit_stock', this.$util.clone(StockUtil.new_stock()));
            this.init();
            // 除柚子鸭团队外，其他默认勾选
            this.edit_stock.auto_balance = this.edit_stock.team_id !== 22
            this.edit_stock.company_code = this.edit_stock.team_id === 22 ? 'LS' : 'CYA'
          }
        
          
        }, 100)
    
    
      },
      iterationChange(val) {
        this.edit_stock.is_iteration = val;
        if (val === false) {
          this.resetIterationStock();
        }
      },
      setFillUser(customer) {
        this.edit_stock.fill_user_id = customer.id;
        this.edit_stock.fill_user = customer.account;
      },
      setApplyUser(customer) {
        if (customer.customer_type && customer.customer_type !== "official") {
          this.edit_stock.apply_user_id = customer.director_id
          CustomerUtil.briefInfo(customer.director_id).then(res => {
            this.edit_stock.apply_user = res.account;
          });
        } else {
          this.edit_stock.apply_user_id = customer.id;
          this.edit_stock.apply_user = customer.account;
        }
        this.setTeam(customer, 'team_id');
        // this.setTeam(customer, 'use_team_id');
      },
      setTeam(customer, key) {
        if (customer.root_team_id) {
          this.edit_stock[key] = customer.root_team_id;
        }
      },
      setIterationStock(stock, version) {
        this.edit_stock.parent_id = stock.id;
        this.edit_stock.version = version;
        this.edit_stock.uid = `${stock.uid}V${version}`;
      },
      resetIterationStock() {
        this.edit_stock.parent_id = 0;
        this.edit_stock.version = 0;
        this.edit_stock.uid = '';
      },
      setProductType(type) {
        this.edit_stock.product_type_id = type.id;
        this.edit_stock.product_type_name = type.full_name;
      },
      setCyaSpu(spu) {
        console.log(spu)
        this.edit_stock.cya_spu_id = spu.id
        this.edit_stock.cya_spu_name = spu.spu_name
      },
      launchDateChange(date) {
        this.edit_stock.launch_date = date;
      },
      getTaxCodes() {
        this.$util.ajax.get(this.$util.api.query_tax_code).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.tax_codes = res.data.items;
          } else {
            this.$Modal.error({
              title: '提示',
              content: res.msg
            })
          }
        }).catch((e) => {
          // console.log(e);
          this.$Message.error({
            title: '提示',
            content: e.message
          });
        });
      },
      setProperty(group) {
        if (group.property) {
          this.edit_stock.property = group.property;
        }
      },
      validateId(rule, value, callback) {
        if (!value || value <= 0) {
          callback(new Error('请选择'));
        } else {
          callback();
        }
      },
      validateIsbn(rule, value, callback) {
        const {_isbn_status, isbn, isbn_delay = {}} = this.edit_stock
        switch (_isbn_status) {
        case '1':
          if (!isbn) {
            callback(new Error('请填写ISBN'));  
            return   
          }
          callback();
          break;
   
        case '3':
          if (!isbn_delay.days) {
            callback(new Error('请选择预计天数'));   
            return 
          }
          callback();
          break;
        case '2':
          callback()
          break;
        default:
          if (!value) {
            callback(new Error('必选'));   
          } else {
            callback()
          }
          break;
        }
     
      },
      validateSpecial(rule, value, callback) {
        if (/[\s-《》]/.test(value)) {
          // callback(new Error('产品名称中不能包含 -、空格、《、》'));
          callback();
        } else {
          callback();
        }
      },
      validateNumber(rule, value, callback) {
        if (['', undefined, null].includes(value)) {
          callback(new Error('请输入金额'));
        } else if (isNaN(value)) {
          callback(new Error('请输入有效金额'));
        } else {
          value = value.trim()
          setTimeout(() => {
            this.edit_stock.cost_unit_price = str2num(value)
          })
          callback()
        }
      },
      validateStockDosage(rule, stock_dosages, callback) {
        if (!stock_dosages) return;
        let err_msg = '';
        stock_dosages.forEach((stock_dosage, i) => {
          if (!stock_dosage.stock_id) {
            err_msg += `●第${i + 1}行:请选择存货 `;
          }
          if (!this.$util.isNumber(stock_dosage.qty)) {
            err_msg += `●第${i + 1}行:请输入正确的数字格式 `;
          } else {
            if (math.eval(`${stock_dosage.qty} <= 0`)) {
              err_msg += `●第${i + 1}行:请填写正确的用量 `;
            }
          }
        });
        if (err_msg) {
          callback(new Error(err_msg));
        } else {
          callback();
        }
      },
      editOk() {
        const edit_stock = JSON.parse(JSON.stringify(this.edit_stock))
        const { del_reason, drop_shipping, cost_unit_price, payee_company_contact_id, _isbn_status, outsource_relation, payee_company_id, imported, is_assemble, stock_dosages, use_team_id, cya_spu_id, cya_spu_name, ...other } = edit_stock
        if (drop_shipping) {
          other.cost_unit_price = cost_unit_price
          other.payee_company_contact_id = payee_company_contact_id
          other.payee_company_id = payee_company_id
          delete other.barcode
        }
        if (other.outsourcing) {
          other.outsource_relation = outsource_relation
        }
        // this.edit_stock.group
        if (this.show_isbn) {
          switch (_isbn_status) {
          case '1':
            delete other.isbn_delay
            break;
          case '2':
            delete other.isbn_delay
            other.isbn = ''
            break
          case '3':
            other.isbn = ''
            break;
          default:
            break;
          }
        } else {
          delete other.isbn_delay
          other.isbn = ''
        }
        if (imported === 'true') {
          other.imported = true
        } else {
          other.imported = false
        }
        this.edit_config.loading = true;
        if (cya_spu_id) {
          other.cya_spu_id = cya_spu_id;
          other.cya_spu_name = cya_spu_name;
        }
        this.$util.ajax.post(this.update_item_path, {
          ...other,
          drop_shipping,
          del_reason: other.del ? del_reason : undefined
        }).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.edit_config.modal = false;
            this.$emit('on-update', res.item);
            this.$Message.success('保存成功!');
          } else {
            this.$Modal.error({title: '提示', content: this.genErrorMsg(res.msg)})
          }
        }).catch((e) => {
          this.$Message.error({title: '提示', content: e.message});
        }).finally(() => {
          this.edit_config.loading = false;
        //  this.resetEditLoading();
        });
      },
      editOkProxy() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const barcode = this.edit_stock.barcode
            
            if (!barcode || (barcode && barcode.trim && !barcode.trim())) {
              this.$vModal.confirm({
                title: '提示',
                content: '该存货代码未填写69码，请尽快补充，否则会影响该存货的正常收发货，请知悉。',
                okText: '继续保存',
                onOk:() => {
                  this.editOk()
                }
              })
            } else if (barcode && (barcode.slice(0, 2) !== '97')) {
              this.edit_config.loading = true;
              stockBarcodeValidateApi({
                barcode: this.edit_stock.barcode
              }).then(res => {
       
                if (!res.flag) {
                  this.$vModal.confirm({
                    title: '69码异常',
                    content: res.remark,
                    okText: '继续保存',
                    onOk:() => {
                      this.editOk()
                    }
                  })
                  return 
                }
                this.editOk()
              }).finally(() => {
                this.edit_config.loading = false;
              })
            } else {
              this.editOk()
            }
          } else {
            this.$Message.error('表单有误, 请检查!');
            //  this.resetEditLoading();
          }
        });
      },
      genErrorMsg(msg) {
        let content = '';
        if (typeof msg === 'string') {
          content = msg;
        } else if (typeof msg === 'object') {
          Object.keys(msg).forEach((key) => {
            content += `<p>${msg[key]}</p>`;
          });
        }
        return content;
      },
      resetEditLoading() {
        this.edit_config.loading = false;
        setTimeout(() => {
          this.edit_config.loading = true;
        }, 500);
      },
      setStockDosage(stock_dosage, stock) {
        if (stock.id === this.edit_stock.id) {
          this.$Modal.error({title: '错误', content: '组合存货不能包含存货本身'});
          return;
        }
        stock_dosage.sub_stock_id = stock.id;
        stock_dosage.stock_uid = stock.uid;
        stock_dosage.stock_name = stock.name;
        stock_dosage.team_id = stock.team_id;
      },
      addStockDosage() {
        this.edit_stock.stock_dosages.push(this.$util.clone(StockUtil.new_stock_dosage));
      },
      delStockDosage(stock_dosage, index) {
        if (stock_dosage.id) {
          this.$util.ajax.post(this.$util.api.delete_stock_dosage, {
            id: stock_dosage.id
          }).then((response) => {
            return response.data;
          }).then((res) => {
            if (res.code === 1) {
              this.edit_stock.stock_dosages.splice(index, 1);
              this.$Message.success('删除成功!');
            } else {
              this.$Modal.error({title: '提示', content: res.msg});
            }
          }).catch((e) => {
            this.$Modal.error({title: '提示', content: e.message});
          });
        } else {
          this.edit_stock.stock_dosages.splice(index, 1);
        }
      },
      uploadedFile(res) {
        this.edit_stock.stock_img = res.file;
      },
      uploadedBarcode(res) {
        this.edit_stock.barcode_img = res.file;
      },
      fileUrl(filepath) {
        return this.$util.publicOSSUrl(filepath);
      }
    }
  }
</script>
